import React, {useRef, useState} from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import logoNewImage from '../../assets/images/logo_new.png';
import hensImg from '../../assets/images/hens.jpeg';
import css from './OurStoryPage.module.css';

import { Page } from '../../components';
import FallbackPage, { fallbackSections } from './FallbackPage';
import { ASSET_NAME } from './OurStoryPage.duck';
import { camelize } from '../../util/string';
import { getMetadata } from '../PageBuilder/PageBuilder';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import OurStoryFooterImg from '../../assets/images/storyFooter.png';
import farmiezTune from './music/countdown.mp3';

export const OurStoryPageComponent = props => {
  const { pageAssetsData } = props;
  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlayPause = () => {
    const audio = audioRef.current;
    console.log('audio', audio)
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }

    setIsPlaying(!isPlaying);
  };

  return (
    <Page {...pageMetaProps} scrollingDisabled={props.scrollingDisabled}>
      <div 
        className={css.OurStoryPage}
        // style={{
        //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        // }}
      >
        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            backgroundImage: `url(${require('../../assets/images/ourStoryHero.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            {/*<img src={logoNewImage} alt="Farmiez Logo" className={css.faqLogo} />*/}
            <h1 className={css.heroTitle}>🌱 Our Story</h1>
            <p className={css.titleBelowText}>Farmiez started with a simple question:</p>
            <p className={css.contentText}>Why is it easier to order food from hundreds or thousands of miles away than from the neighbor down the street?</p>
          </div>
          
        </div>

        <div 
          className={css.aboutContentWrap}
          // style={{
          //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
          // }}
        >
          {/* Content Section */}
          <div className={css.contentSection}>
            <div className={css.textBlock}>
              <p>Across neighborhoods everywhere, people grow incredible food in their own backyards — vegetables, herbs, fruit, honey, baked goods, flowers, eggs, and more.</p>

              <p>Farmiez was created to change that. <br/>What began with neighbors sharing fresh eggs from backyard coops quickly revealed something bigger: a growing network of gardeners, growers, and small producers who wanted a simple way to share what they grow with their community.</p>

              <p>So Farmiez became a hyperlocal marketplace designed to connect everyday growers with nearby buyers who value fresh, local food.</p>

              <h3>🌿 From Backyard Gardens to Local Marketplace</h3>
              <p>Farmiez makes it easy to discover fresh local food right down the street.</p>
              <p>Whether someone is harvesting vegetables from raised beds, baking bread in their kitchen, tending herbs in containers, or collecting eggs from a backyard coop, Farmiez helps neighbors connect and share what they grow and create.</p>
              <p>Instead of shipping food across the country, Farmiez brings communities closer together — one local pickup at a time.</p>

              <h3>🌎 Our Vision</h3>
              <p>We believe the future of food is local, transparent, and community-powered.</p>
              <p>Farmiez is building a modern farmers market experience that lives online — one that supports small growers, keeps food dollars in local neighborhoods, and helps people reconnect with where their food comes from.</p>
              <ul>
                <li>
                  <div className={css.liHead}>Our goal is simple:</div>
                  <div className={css.liText}>Make it easy for anyone growing or producing food locally to share it with their community.</div>
                </li>
              </ul>

              <h3>🤝 A Community Built Around Local Food</h3>
              <p>Farmiez is designed for the people who care about food and community:</p>
              
              <div className={css.bulletText}>• Backyard gardeners</div>
              <div className={css.bulletText}>• Small-scale growers</div>
              <div className={css.bulletText}>• Home bakers and makers</div>
              <div className={css.bulletText}>• Neighbors looking for fresh local products</div>

              <p>Every listing on Farmiez represents something grown, made, or produced by someone nearby.</p>

              <div className={css.bulletText}>When you buy through Farmiez, you're not just buying food — you're supporting the people in your own community.</div>

              <h3>Welcome to Farmiez Marketplace.</h3>
              <p>Let’s bring local food back to the neighborhood.</p>

            </div>
          </div>

          <div className={css.footerImgWrap}>
            <img src={OurStoryFooterImg} alt="img" className={css.footerImg} />
          </div>
        </div>
        <FooterContainer />
      </div>
    </Page>
  );
};

OurStoryPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData } = state.hostedAssets || {};

  return {
    pageAssetsData,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const OurStoryPage = compose(connect(mapStateToProps))(OurStoryPageComponent);

export default OurStoryPage;
